module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\"><path fill=\"#8F8F8F\" fill-rule=\"evenodd\" d=\"M28.777 18c-.91-4.008-4.494-7-8.777-7-4.283 0-7.868 2.992-8.777 7H4.01C2.9 18 2 18.895 2 20c0 1.112.9 2 2.01 2h7.213c.91 4.008 4.494 7 8.777 7 4.283 0 7.868-2.992 8.777-7h7.214C37.1 22 38 21.105 38 20c0-1.112-.9-2-2.01-2h-7.213zM20 25c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./cycle_analytics/svg/icon_commit.svg
// module id = ./cycle_analytics/svg/icon_commit.svg
// module chunks = pages.projects.cycle_analytics.show